(function () {
  var BRANDS = [
    { name: 'Nike', d: 0 }, { name: 'Adidas', d: 0 }, { name: 'Puma', d: 0 }, { name: 'New Balance', d: 0 },
    { name: 'Jordan', d: 0 }, { name: 'Under Armour', d: 0 }, { name: 'Vans', d: 0 }, { name: 'Hoka', d: 0 },
    { name: 'On', d: 0 }, { name: 'Reebok', d: 0 },
    { name: 'Converse', d: 0.5, note: 'Converse usually runs about half a size big, so we went up half a size from your Converse size.' },
    { name: 'Asics', d: -0.5, note: 'Asics tends to run a little small, so we went down half a size from your Asics size.' },
    { name: 'Another brand', d: 0 }
  ];
  var MIN = 3.5, MAX = 12;

  var dlg, sheet, body, variants = {}, state, stack, lockY = 0, locked = false;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function btn(cls, text, fn) {
    var b = el('button', cls, text);
    b.type = 'button';
    b.addEventListener('click', fn);
    return b;
  }
  function title(m) { return 'M' + m + ' - W' + (m + 1.5); }

  // ---------- keep the page still behind the pop-up ----------
  // The page is frozen in place (not just set to overflow: hidden, which phones ignore) and put back on close.
  function lock() {
    if (locked) return;
    locked = true;
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var s = document.body.style;
    s.position = 'fixed';
    s.top = (-lockY) + 'px';
    s.left = '0';
    s.right = '0';
    s.width = '100%';
    s.overflowY = 'scroll';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var s = document.body.style;
    s.position = s.top = s.left = s.right = s.width = s.overflowY = '';
    window.scrollTo({ top: lockY, left: 0, behavior: 'instant' });
  }

  // ---------- add to cart / email me, using the page's own size picker and buttons ----------
  function sizeLabel(t) {
    var labels = document.querySelectorAll('.globo-swatch-list label');
    for (var i = 0; i < labels.length; i++) if (labels[i].textContent.trim() === t) return labels[i];
    return null;
  }
  function selectSize(t) {
    var l = sizeLabel(t);
    if (!l) return false;
    var inp = document.getElementById(l.getAttribute('for'));
    if (!(inp && inp.checked)) l.click();
    return true;
  }
  function mainBuy() {
    var list = document.querySelectorAll('.product-info buy-buttons');
    for (var i = 0; i < list.length; i++) if (!list[i].closest('quick-buy-modal')) return list[i];
    return null;
  }
  function currentId() {
    var bb = mainBuy();
    var form = bb && document.getElementById(bb.getAttribute('form'));
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  function addToCart(t) {
    close();
    var id = String(variants[t].i);
    selectSize(t);
    var tries = 0;
    (function wait() {
      var bb = mainBuy();
      var b = bb && bb.querySelector('button[type="submit"]');
      if (b && currentId() === id && !b.disabled) {
        setTimeout(function () { b.click(); }, 200);
        return;
      }
      if (++tries < 40) { setTimeout(wait, 100); return; }
      // The page's picker didn't respond: add it directly and show the cart
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
        .then(function () { window.location.href = '/cart'; });
    })();
  }

  // Opens this page on that size with #notify: the page then opens the back-in-stock sign-up for it
  // (the same thing the quick view's "Email me when available" link does)
  function notifyMe(t) {
    close();
    var url = location.pathname + '?variant=' + variants[t].i + '#notify';
    if (location.pathname + location.search + location.hash === url) location.reload();
    else location.href = url;
  }

  // ---------- the questions ----------
  function steps() { return state.path === 'foot' ? 3 : 4; }

  function frame(stepNo, question) {
    body.innerHTML = '';
    if (stack.length > 1) body.appendChild(btn('sq__back', '← Back', function () { stack.pop(); render(stack[stack.length - 1]); }));
    if (stepNo) body.appendChild(el('p', 'sq__step', 'Step ' + stepNo + ' of ' + steps()));
    if (question) body.appendChild(el('p', 'sq__q', question));
  }
  function go(step) { stack.push(step); render(step); }

  function render(step) {
    if (step === 'gender') {
      frame(1, 'Do you usually buy men’s or women’s sizes?');
      var g = el('div', 'sq__chips');
      g.appendChild(btn('sq__chip', 'Men’s', function () { state.gender = 'm'; go('brand'); }));
      g.appendChild(btn('sq__chip', 'Women’s', function () { state.gender = 'w'; go('brand'); }));
      body.appendChild(g);
    } else if (step === 'brand') {
      frame(2, 'What brand do you wear most?');
      var c = el('div', 'sq__chips');
      BRANDS.forEach(function (b) {
        c.appendChild(btn('sq__chip', b.name, function () { state.path = 'brand'; state.brand = b; go('size'); }));
      });
      body.appendChild(c);
      body.appendChild(btn('sq__link', 'I’d rather use my foot length', function () { state.path = 'foot'; go('foot'); }));
    } else if (step === 'size') {
      frame(3, 'What size do you wear in ' + state.brand.name + '?');
      var lo = state.gender === 'm' ? 3.5 : 5, hi = state.gender === 'm' ? 13 : 14.5;
      var s = el('div', 'sq__chips sq__chips--sizes');
      for (var n = lo; n <= hi; n += 0.5) {
        (function (size) {
          s.appendChild(btn('sq__chip', String(size), function () { state.size = size; go('width'); }));
        })(n);
      }
      body.appendChild(s);
      body.appendChild(el('p', 'sq__hint', (state.gender === 'm' ? 'Men’s' : 'Women’s') + ' sizes, US.'));
    } else if (step === 'foot') {
      frame(2, 'How long is your foot?');
      var input = el('input', 'sq__field');
      input.type = 'number';
      input.inputMode = 'numeric';
      input.placeholder = 'Length in mm, like 270';
      body.appendChild(input);
      body.appendChild(el('p', 'sq__hint', 'Stand on a piece of paper, mark your heel and your longest toe, then measure the gap in millimeters. Most adult feet are between 230 and 300.'));
      var msg = el('p', 'sq__hint');
      body.appendChild(msg);
      body.appendChild(btn('sq__cta', 'Continue', function () {
        var v = Number(input.value);
        if (!v || v < 200 || v > 340) { msg.textContent = 'Enter your foot length in millimeters, like 270.'; return; }
        state.len = v;
        go('width');
      }));
    } else if (step === 'width') {
      frame(state.path === 'foot' ? 3 : 4, 'How wide are your feet?');
      var w = el('div', 'sq__chips sq__chips--three');
      [['Narrow', 'narrow'], ['Average', 'average'], ['Wide', 'wide']].forEach(function (o) {
        w.appendChild(btn('sq__chip', o[0], function () { state.width = o[1]; go('result'); }));
      });
      body.appendChild(w);
      body.appendChild(el('p', 'sq__hint', 'Wide feet: we’ll go up half a size so they aren’t squeezed.'));
    } else {
      renderResult();
    }
    // The button that was just clicked is gone, so park focus on the pop-up itself without scrolling anything
    dlg.scrollTop = 0;
    if (sheet && sheet.focus) sheet.focus({ preventScroll: true });
  }

  function renderResult() {
    var m, why;
    if (state.path === 'foot') {
      m = Math.ceil((7 + (state.len - 250) / 10) * 2) / 2;
      why = 'Your foot is about ' + state.len + ' mm, which lines up with this size in our size guide.';
    } else {
      var base = state.gender === 'w' ? state.size - 1.5 : state.size;
      m = Math.round((base + state.brand.d) * 2) / 2;
      var shown = (state.gender === 'm' ? 'men’s ' : 'women’s ') + state.size;
      why = 'You wear a ' + shown + ' in ' + state.brand.name + '. ';
      if (state.brand.note) why += state.brand.note;
      else if (state.brand.name === 'Another brand') why += 'Our cleats fit true to standard US sizing, so if your shoes fit you true to size, this should be your size.';
      else why += state.brand.name + ' sizing is close to ours, so we kept the same size.';
    }
    if (state.width === 'wide') { m += 0.5; why += ' Because your feet are wide, we went up half a size.'; }

    frame(0, '');
    if (m < MIN || m > MAX) {
      body.appendChild(el('p', 'sq__q', 'We’re not sure about that one'));
      body.appendChild(el('p', 'sq__why', 'Our sizes run from M' + MIN + ' to M' + MAX + ', and this one falls outside that. Email hello@mirrorlessapparel.com and we’ll help you out.'));
      body.appendChild(btn('sq__link', 'Start over', start));
      return;
    }

    var t = title(m), rec = variants[t];
    body.appendChild(el('p', 'sq__step', 'Your size'));
    body.appendChild(el('p', 'sq__size', t.replace(' - ', ' – ')));
    body.appendChild(el('p', 'sq__why', why));

    if (rec && rec.a) {
      body.appendChild(btn('sq__cta', 'Add ' + t + ' to cart', function () { addToCart(t); }));
      body.appendChild(el('p', 'sq__note', 'Easy returns if it doesn’t fit right (free on US orders).'));
    } else {
      body.appendChild(el('p', 'sq__why', (rec ? 'Your size is out of stock right now. ' : 'We don’t have that size right now. ') + 'The good news is every pair has easy returns (free on US orders), so you can safely try a size right next to it.'));
      var options = [[m + 0.5, 'a little roomier'], [m - 0.5, 'a little snugger'], [m + 1, 'roomier'], [m - 1, 'snugger']];
      var shownCount = 0;
      options.forEach(function (o) {
        var ot = title(o[0]);
        if (shownCount >= 2 || !variants[ot] || !variants[ot].a) return;
        shownCount++;
        var b = btn('sq__cta sq__cta--alt', 'Add ' + ot + ' to cart', function () { addToCart(ot); });
        b.appendChild(el('small', '', o[1]));
        body.appendChild(b);
      });
      if (rec) body.appendChild(btn('sq__link', 'Email me when ' + t + ' is back', function () { notifyMe(t); }));
    }
    body.appendChild(btn('sq__link', 'Start over', start));
  }

  function start() { state = {}; stack = ['gender']; render('gender'); }

  function open() {
    if (!dlg.showModal) return;
    lock();
    start();
    dlg.showModal();
    if (sheet && sheet.focus) sheet.focus({ preventScroll: true });
  }
  function close() { if (dlg.open) dlg.close(); else unlock(); }

  function init() {
    dlg = document.getElementById('size-quiz');
    sheet = dlg && dlg.querySelector('.sq__sheet');
    body = dlg && dlg.querySelector('[data-sq-body]');
    var data = document.querySelector('script[data-sq-data]');
    if (!dlg || !body || !data) return;
    try { JSON.parse(data.textContent).forEach(function (v) { variants[v.t] = v; }); } catch (e) { return; }
    if (sheet) sheet.setAttribute('tabindex', '-1');

    dlg.addEventListener('close', function () {
      unlock();
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    });
    // Touches on the dimmed area around the pop-up never scroll the page
    dlg.addEventListener('touchmove', function (e) { if (e.target === dlg) e.preventDefault(); }, { passive: false });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-size-quiz-open]')) { open(); return; }
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-sq-close]'))) close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();